import React, { useState } from 'react';

import { Avatar, Col, Divider, Modal, Row, Steps, Table } from 'antd';
import { InboxOutlined, RightOutlined, ShopOutlined, CheckCircleOutlined, CarOutlined } from '@ant-design/icons';
import UserProfileForm from './ProfileForm';
import MyButton from './Button';
import CustomerForm from './CustomerForm';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import { ASSET_BASE_PATH } from '../constants/Config';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import _ from 'lodash';
import '../index.css';
import { FormattedMessage } from 'react-intl';

const { Step } = Steps;

// import { useState } from "react";

const TrackingModal = (props) => {
  const { isOpen, onCancle, data, trackingDetail } = props;
  const statusTracking  = _.get(trackingDetail,'statusTracking');

  const isDesktop = useIsDesktop();

  const customDot = (dot, { status, index, title }) => {
    if (status === 'wait') {
      <Typography size={'18px'} color={COLORS.Primary} isBold className='pb-2'>
        {title}
      </Typography>;
    } else if (status === 'procress') {
    }
  };

  return (
    <Modal
      title={
        <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
          <FormattedMessage id='labelTracking' defaultMessage='Tracking' />
        </Typography>
      }
      open={isOpen}
      onOk={() => {}}
      onCancel={onCancle}
      centered={isDesktop ? true : false}
      width={620}
      footer={[
        <MyButton
          // key="back"
          className={`${isDesktop ? 'w-25' : 'w-100'}`}
          isPrimary
          onClick={onCancle}
          // onClick={isEdit ? handleClickCancelEdit : onCancle}
        >
          <FormattedMessage id='btnClose' defaultMessage='Close' />
        </MyButton>,
      ]}
    >
      <Divider className='m-0 mb-4' />
      <Row className={`${isDesktop ? 'px-2' : ''}`} align='middle'>
        <Col span={isDesktop ? 4 : 5}>
          <div>
            <Avatar className='avatar-container' style={{ backgroundColor: COLORS.Primary, display: 'flex' }} size={isDesktop ? 64 : 52}>
              <img
                style={{ height: isDesktop ? '62px' : '50px', width: '50px', filter: 'brightness(0) invert(1)', display: 'block' }}
                src={_.get(trackingDetail, 'IconTrackingCurrentStatus')}
                alt='Your SVG'
              />
            </Avatar>
          </div>
        </Col>
        <Col span={isDesktop ? 7 : 10}>
          <Typography size={'18px'} color={COLORS.Primary} isBold className='pb-2'>
            {_.get(data, 'pacelNo')}
          </Typography>
        </Col>
      </Row>
      <Row className={`pt-4 ${isDesktop ? 'px-2' : ''}`}>
        <Col span={isDesktop ? 10 : 12}>
          <div>
            <Typography size={'16px'} color={COLORS.DarkGray} isBold className='pb-2'>
            <FormattedMessage id='textFrom' defaultMessage='From' /> : {_.get(trackingDetail, 'senderName')}
            </Typography>
          </div>
        </Col>
        <Col span={isDesktop ? 5 : 2} />
        <Col span={isDesktop ? 6 : 8}>
          <div>
            <Typography size={'16px'} color={COLORS.DarkGray} isBold className='pb-2'>
            <FormattedMessage id='textTo' defaultMessage='To' /> : {_.get(trackingDetail, 'recipientName')}
            </Typography>
          </div>
        </Col>
      </Row>
      <Divider className='m-0 mt-4 mb-4' />
      <>
        <Steps progressDot direction='vertical' current={trackingDetail.currentStatusIndex}>
          {_.map(statusTracking, (item, key) => {
            return (
              <Steps
                key={key}
                title={item.statusName}
                description={
                  <Row className='p-2 pt-2'>
                    <Col span={isDesktop ? 12 : 24} className='d-flex flex-nowrap align-items-center'>
                      <Typography color={'#909aaf'} size={isDesktop ? '12px' : '12px'}>{item.statusDescription}</Typography>
                    </Col>
                    <Col span={isDesktop ? 12 : 24}>
                      <Typography
                        color={'#909aaf'}
                        size={isDesktop ? '12px' : '12px'}
                        className={`${isDesktop ? 'text-right' : 'text-left px-0 pt-2'}`}
                      >
                        {item.timestampTxt}
                      </Typography>
                    </Col>
                  </Row>
                }
              />
            );
          })}
        </Steps>
      </>
      {isDesktop && <Divider className='m-0 mt-5' />}
    </Modal>
  );
};

export default TrackingModal;
